export const blockIconsMapsRestaurantMenu = (
	<span className='material-symbols-outlined'>restaurant_menu</span>
);
